// Generated by CoffeeScript 1.9.2
var isArray;

isArray = require('isarray');

module.exports = function(props, state) {
  var childComponentWidth, componentsPerRow, idealComponentsPerRow;
  if (props.margin === 0) {
    idealComponentsPerRow = state.componentWidth / props.targetWidth;
  } else {
    idealComponentsPerRow = ((state.componentWidth / props.margin) + 1) / ((props.targetWidth / props.margin) + 1);
  }
  componentsPerRow = Math.round(idealComponentsPerRow);
  childComponentWidth = ((state.componentWidth + props.margin) / componentsPerRow) - props.margin;
  return [childComponentWidth, componentsPerRow];
};
